import { render, staticRenderFns } from "./legal-checkbox-agreement.vue?vue&type=template&id=2bd4f12b&scoped=true&"
import script from "./legal-checkbox-agreement.vue?vue&type=script&lang=js&"
export * from "./legal-checkbox-agreement.vue?vue&type=script&lang=js&"
import style0 from "./legal-checkbox-agreement.vue?vue&type=style&index=0&id=2bd4f12b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4f12b",
  null
  
)

export default component.exports